import ChartPanel from "../conponents/common/ChartPanel";
import TimeSelector from "../conponents/common/TimeSelector";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ECharts from "../conponents/common/ECharts";
import {
  fetchChartData,
  selectChartDataByType,
} from "../store/informationSlice";
import { memo } from "react";
import formatDateTime from "../conponents/common/FormatDateTime";
import { toast } from "react-toastify";
const ChartComponent = memo(
  ({
    type,
    data,
    className = "w-full",
    hasTimeRange = false,
    chartState,
    onUpdateDate,
    onUpdateTimeRange,
    children,
    minHeight = 500, // 可配置的最小高度
    maxHeight, // 可選的最大高度限制
  }) => {
    // const [containerHeight, setContainerHeight] = useState(minHeight);
    const containerRef = useRef(null);

    // 監聽容器變化，動態調整高度
    // useEffect(() => {
    //   if (!containerRef.current) return;

    //   const resizeObserver = new ResizeObserver((entries) => {
    //     for (let entry of entries) {
    // const { height } = entry.contentRect;
    // const newHeight = Math.max(height, minHeight);
    // const finalHeight = maxHeight
    //   ? Math.min(newHeight, maxHeight)
    //   : newHeight;
    // setContainerHeight(finalHeight);
    //   }
    // });

    //   resizeObserver.observe(containerRef.current);
    //   return () => resizeObserver.disconnect();
    // }, [minHeight, maxHeight]);

    const generateChartOption = useCallback((type, data) => {
      if (!data) return { title: `Chart ${type}` };
      return {
        ...data.data.option,
        // 確保圖表配置適應容器
        grid: {
          ...data.data.option.grid,
          containLabel: true,
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
        },
      };
    }, []);

    const renderTimeRangeSelector = useCallback(
      (type) => {
        const timeRanges = ["1D", "1W", "1M", "1Y"];

        return (
          <div className="flex gap-2 md:gap-[32px] items-center h-fit">
            <div className="hidden md:flex items-center gap-2">
              {timeRanges.map((range) => (
                <button
                  key={range}
                  onClick={() => onUpdateTimeRange(type, range)}
                  className={`w-[38px] h-[38px] rounded-[8px] bg-[#1A111D]/70 text-[14px] font-medium ${
                    chartState?.active === range
                      ? "text-white"
                      : "text-[#868B93]"
                  }`}
                >
                  {range}
                </button>
              ))}
            </div>

            <div className="flex md:hidden">
              <select
                value={chartState?.active || "1D"}
                onChange={(e) => onUpdateTimeRange(type, e.target.value)}
                className="w-[56px] h-[43px] rounded-[8px] bg-[#1A111D]/70 text-white text-[14px] font-medium px-2"
              >
                {timeRanges.map((range) => (
                  <option key={range} value={range}>
                    {range}
                  </option>
                ))}
              </select>
            </div>
            <TimeSelector
              onChange={(date) => onUpdateDate(type, date)}
              nowBtn={false}
            />
          </div>
        );
      },
      [chartState?.active, onUpdateTimeRange, onUpdateDate]
    );

    const option = useMemo(
      () => generateChartOption(type, data),
      [type, data, generateChartOption]
    );

    return (
      <div className={className}>
        <ChartPanel className="w-full">
          <div
            ref={containerRef}
            className={`min-h-[${minHeight}px] ${
              maxHeight ? `max-h-[${maxHeight}px]` : ""
            } flex flex-col gap-4 w-full p-4 rounded-[16px] bg-[linear-gradient(135deg,_#00000033,_#66666633)]`}
          >
            {/* 頂部控制區域 */}
            <div className="flex flex-col lg:flex-row items-center justify-between w-full gap-2 flex-shrink-0">
              <div className="flex rounded-[16px] w-fit items-center justify-center p-2 px-4 bg-[#388296] border border-[#575757] text-white font-bold text-[20px]">
                {option.title || option.title.text || ""}
              </div>
              {hasTimeRange ? (
                renderTimeRangeSelector(type)
              ) : (
                <div className="flex gap-[32px] items-center">
                  <TimeSelector
                    onChange={(date) => onUpdateDate(type, date)}
                    nowBtn={false}
                  />
                </div>
              )}
            </div>

            {/* children 內容區域 */}
            {children && <div className="flex-shrink-0">{children}</div>}

            {/* 圖表區域 - 完全響應式 */}
            <div className="flex-1 w-full">
              <ECharts
                option={option}
                theme="dark"
                type={type}
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: minHeight, // 圖表本身的最小高度
                }}
                opts={{
                  renderer: "svg", // 使用 SVG 渲染器，更好的縮放性能
                  width: "auto",
                  height: "auto",
                }}
              />
            </div>
          </div>
        </ChartPanel>
      </div>
    );
  }
);

ChartComponent.displayName = "ChartComponent";

function Statistics() {
  const dispatch = useDispatch();

  // 每個圖表的獨立狀態 - 只有第5個需要 active 狀態 第10個要另外三個值
  const [chartStates, setChartStates] = useState({
    3: { selectedDate: "" },
    4: { selectedDate: "" },
    5: { active: "1D", selectedDate: "" }, // 只有第5個有 active
    6: { selectedDate: "" },
    7: { selectedDate: "" },
    8: { selectedDate: "" },
    9: { selectedDate: "" },
    10: {
      selectedDate: "",
      selectedUnit: "",
      selectedTimeRange: "",
      selectedCircuits: [],
    },
  });

  // 使用你現有的 selector 取得各類型圖表數據
  const chartData3 = useSelector(selectChartDataByType(3));
  const chartData4 = useSelector(selectChartDataByType(4));
  const chartData5 = useSelector(selectChartDataByType(5));
  const chartData6 = useSelector(selectChartDataByType(6));
  const chartData7 = useSelector(selectChartDataByType(7));
  const chartData8 = useSelector(selectChartDataByType(8));
  const chartData9 = useSelector(selectChartDataByType(9));
  const chartData10 = useSelector(selectChartDataByType(10));
  // 初始化時載入所有需要的圖表數據
  useEffect(() => {
    [3, 4, 5, 6, 7, 8, 9, 10].forEach((type) => {
      const state = chartStates[type];
      dispatch(
        fetchChartData({
          type,
          date: state.selectedDate,
        })
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 使用 useCallback 避免函數重新創建導致子組件重新渲染
  const updateTimeRange = useCallback(
    (type, newRange) => {
      // 只有第5個圖表需要更新 active 狀態
      if (type === 5) {
        setChartStates((prev) => ({
          ...prev,
          [type]: { ...prev[type], active: newRange },
        }));

        dispatch(
          fetchChartData({
            type,
            date: chartStates[type].selectedDate,
            timeRange: newRange, // 如果需要的話，也可以傳遞時間範圍參數
          })
        );
      }
    },
    [dispatch, chartStates]
  );

  // 使用 useCallback 避免函數重新創建導致子組件重新渲染
  const updateDate = useCallback(
    (type, newDate) => {
      // 處理日期格式化 - newDate 可能是字串或 Date 物件
      const formattedDate = formatDateTime(newDate);

      setChartStates((prev) => ({
        ...prev,
        [type]: { ...prev[type], selectedDate: formattedDate },
      }));
      //type===10不觸發送出
      if (type !== 10) {
        // 只更新這個特定 type 的數據，使用新的日期
        dispatch(
          fetchChartData({
            type,
            date: formattedDate,
          })
        );
      }
    },
    [dispatch]
  );

  // 新增：統一的狀態更新函數
  const updateChartState = useCallback((type, updates) => {
    setChartStates((prev) => ({
      ...prev,
      [type]: { ...prev[type], ...updates },
    }));
  }, []);

  // type 10 專用的更新函數
  const updateUnit = useCallback(
    (newUnit) => {
      updateChartState(10, { selectedUnit: newUnit });
    },
    [updateChartState]
  );

  const updateTimeRangeForType10 = useCallback(
    (newTimeRange) => {
      updateChartState(10, { selectedTimeRange: newTimeRange });
    },
    [updateChartState]
  );

  const updateCircuits = useCallback(
    (newCircuits) => {
      updateChartState(10, { selectedCircuits: newCircuits });
    },
    [updateChartState]
  );

  const handleQuery = useCallback(() => {
    const type10State = chartStates[10];

    // 檢查缺少的資料
    const missingFields = [];

    if (!type10State.selectedDate) {
      missingFields.push("查詢日期");
    }
    if (!type10State.selectedUnit) {
      missingFields.push("查詢參數");
    }
    if (!type10State.selectedTimeRange) {
      missingFields.push("時間範圍");
    }
    if (
      !type10State.selectedCircuits ||
      type10State.selectedCircuits.length === 0
    ) {
      missingFields.push("監測迴路");
    }

    if (missingFields.length > 0) {
      const missingText = missingFields.join("、");
      toast.error(`請填入所有資訊：${missingText}`);
      return;
    }

    // 所有資料都已填寫，觸發數據查詢
    console.log("查詢參數:", {
      date: type10State.selectedDate,
      unit: type10State.selectedUnit,
      timeRange: type10State.selectedTimeRange,
      circuits: type10State.selectedCircuits,
    });

    dispatch(
      fetchChartData({
        type: 10,
        date: type10State.selectedDate,
        unit: type10State.selectedUnit,
        timeRange: type10State.selectedTimeRange,
        circuits: type10State.selectedCircuits,
      })
    );
  }, [dispatch, chartStates]);

  // === 統計卡片組件 ===
  const StatCard = ({ title, value, unit = "" }) => {
    return (
      <div className="w-full mx-auto">
        {/* 標題區塊 - 灰色背景，圓角上方 */}
        <div className="bg-gray-500 text-white text-center py-3 rounded-t-xl font-medium">
          {title}
        </div>

        {/* 內容區塊 - 白色背景，圓角下方 */}
        <div className="rounded-b-xl border border-gray-200 p-8 text-center min-h-[120px] flex items-center justify-center">
          <div>
            <div className="text-white text-2xl font-bold">{value}</div>
            <div className="text-white text-2xl font-bold">{unit}</div>
          </div>
        </div>
      </div>
    );
  };

  // === 3. 監測迴路多選組件 ===
  const CircuitCheckboxes = ({
    selectedCircuits,
    onCircuitChange,
    circuitOptions,
  }) => {
    const handleCheckboxChange = (circuitId) => {
      const updatedCircuits = selectedCircuits.includes(circuitId)
        ? selectedCircuits.filter((id) => id !== circuitId)
        : [...selectedCircuits, circuitId];
      onCircuitChange(updatedCircuits);
    };

    return (
      <div className="col-span-full">
        <label className="block text-gray-300 text-sm mb-3">監測迴路</label>
        <div className="bg-gray-700 border border-cyan-400 rounded-lg p-4">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {circuitOptions.map((circuit) => (
              <div key={circuit.id} className="space-y-3">
                <label
                  key={circuit.id}
                  className="flex items-center text-sm text-gray-300 cursor-pointer hover:text-white transition-colors"
                >
                  <input
                    type="checkbox"
                    checked={selectedCircuits.includes(circuit.id)}
                    onChange={() => handleCheckboxChange(circuit.id)}
                    className="mr-2 w-4 h-4 text-cyan-400 bg-gray-600 border-gray-500 rounded focus:ring-cyan-400 focus:ring-2"
                  />
                  <span>{circuit.label}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // === 1. 單位選擇組件 ===
  const UnitSelector = ({ selectedUnit, onUnitChange, unitOptions }) => {
    return (
      <div>
        <label className="block text-gray-300 text-sm mb-2">查詢參數</label>
        <select
          value={selectedUnit}
          onChange={(e) => onUnitChange(e.target.value)}
          className="w-full bg-gray-700 border border-cyan-400 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-cyan-300"
        >
          <option value={""} className="bg-gray-700">
            請選擇
          </option>
          {unitOptions.map((unit, index) => (
            <option key={index} value={unit.value} className="bg-gray-700">
              {unit.label}
            </option>
          ))}
        </select>
      </div>
    );
  };

  // === 2. 時間區間組件 ===
  const TimeRangeSelector = ({
    selectedTimeRange,
    onTimeRangeChange,
    timeRangeOptions,
  }) => {
    return (
      <div>
        <label className="block text-gray-300 text-sm mb-2">時間範圍</label>
        <select
          value={selectedTimeRange}
          onChange={(e) => onTimeRangeChange(e.target.value)}
          className="w-full bg-gray-700 border border-cyan-400 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-cyan-300"
        >
          <option value={""} className="bg-gray-700">
            請選擇
          </option>
          {timeRangeOptions.map((range, index) => (
            <option key={index} value={range.value} className="bg-gray-700">
              {range.label}
            </option>
          ))}
        </select>
      </div>
    );
  };

  return (
    <>
      <div className="flex flex-col lg:flex-row w-full gap-2">
        <ChartComponent
          type={3}
          data={chartData3}
          className="w-full lg:w-1/2"
          chartState={chartStates[3]}
          onUpdateDate={updateDate}
          onUpdateTimeRange={updateTimeRange}
        />
        <ChartComponent
          type={4}
          data={chartData4}
          className="w-full lg:w-1/2"
          chartState={chartStates[4]}
          onUpdateDate={updateDate}
          onUpdateTimeRange={updateTimeRange}
        />
      </div>

      <ChartComponent
        type={5}
        data={chartData5}
        hasTimeRange={true}
        chartState={chartStates[5]}
        onUpdateDate={updateDate}
        onUpdateTimeRange={updateTimeRange}
      />

      <ChartComponent
        type={6}
        data={chartData6}
        chartState={chartStates[6]}
        onUpdateDate={updateDate}
        onUpdateTimeRange={updateTimeRange}
      />

      <ChartComponent
        type={7}
        data={chartData7}
        chartState={chartStates[7]}
        onUpdateDate={updateDate}
        onUpdateTimeRange={updateTimeRange}
      />

      <div className="flex flex-col lg:flex-row w-full gap-2">
        <ChartComponent
          type={8}
          data={chartData8}
          className="w-full lg:w-1/2"
          chartState={chartStates[8]}
          onUpdateDate={updateDate}
          onUpdateTimeRange={updateTimeRange}
        />
        <ChartComponent
          type={9}
          data={chartData9}
          className="w-full lg:w-1/2"
          chartState={chartStates[9]}
          onUpdateDate={updateDate}
          onUpdateTimeRange={updateTimeRange}
        />
      </div>

      <ChartComponent
        type={10}
        data={chartData10}
        chartState={chartStates[10]}
        onUpdateDate={updateDate}
        onUpdateTimeRange={updateTimeRange}
        className="h-fit"
      >
        <div className="mx-auto space-y-6">
          <div className="grid grid-cols-2 md:grid-cols-8 lg:grid-cols-12 gap-4 items-end">
            <div className="col-span-2">
              <UnitSelector
                selectedUnit={chartStates[10].selectedUnit}
                onUnitChange={updateUnit}
                unitOptions={chartData10?.unitOptions || []}
              />
            </div>

            <div className="col-span-2">
              <TimeRangeSelector
                selectedTimeRange={chartStates[10].selectedTimeRange}
                onTimeRangeChange={updateTimeRangeForType10}
                timeRangeOptions={chartData10?.timeRangeOptions || []}
              />
            </div>

            <div className="col-span-6 hidden lg:block"></div>

            <div className="col-span-2 md:col-start-7 lg:col-start-11">
              <button
                onClick={handleQuery}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
              >
                查詢
              </button>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-4">
            <CircuitCheckboxes
              selectedCircuits={chartStates[10].selectedCircuits}
              onCircuitChange={updateCircuits}
              circuitOptions={chartData10?.circuitOptions || []}
            />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <StatCard title="查詢範圍" value={chartData10?.detail?.range} />
            <StatCard title="數據點數" value={chartData10?.detail?.points} />
            <StatCard title="迴路數量" value={chartData10?.detail?.circuits} />
            <StatCard title="平均值" value={chartData10?.detail?.average} />
          </div>
        </div>
      </ChartComponent>
    </>
  );
}

export default Statistics;
